import { InfoCircleOutlined } from '@ant-design/icons'
import { LastReadingPopover } from '@components/_SiteWide/TankDisplay/LastReadingPopover'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import cnf from '@utils/cell_formatter'
import { ReadableDifference } from '@utils/general'
import { Card, Col, Popover, Row } from 'antd'
import React, { useMemo } from 'react'

export function TankStats({ tank, tankRundownData, selectedManifold, timezone, rundownToggled, store }) {
  const Cards = (tankOrManifold, tankRundownData) => {
    return [
      { title: 'Estimated Current Volume', value: cnf.reg(tankOrManifold.current_volume) },
      { title: 'Target Minimum', value: cnf.reg(tankOrManifold.model_target_min) },
      { title: 'Target Maximum', value: cnf.reg(tankOrManifold.model_target_max) },
      { title: 'Max Volume', value: cnf.reg(tankOrManifold.storage_max) },
      { title: 'Tank Size', value: cnf.reg(tankOrManifold.tank_size) },
      {
        title: 'Runout Time',
        value: ReadableDifference(
          rundownToggled ? tankOrManifold?.run_out_date_with_drops : tankOrManifold?.run_out_date,
          undefined,
          true
        ),
      },
    ]
  }

  const tankOrManifoldItem = useMemo(() => {
    if (selectedManifold) return selectedManifold
    if (tank?.manifold_id && store) {
      const manifoldGroup = store?.grouped_tanks.find((group) =>
        group.manifold_tanks.some((manifold) => manifold.manifold_id === store.tanks[0].manifold_id)
      )
      const manifold = manifoldGroup?.manifold_tanks?.find(
        (manifold) => manifold.manifold_id === store.tanks[0].manifold_id
      )
      return {
        ...tank,
        run_out_date: manifold?.run_out_date,
        run_out_date_with_drops: manifold?.run_out_date_with_drops,
      }
    }
    return tank
  }, [selectedManifold, tank, store])
  const cards = Cards(tankOrManifoldItem, tankRundownData)

  function HorizontalCardGroup({ cards, tankRundownData }) {
    const spanSize = ~~(24 / cards.length)
    return (
      <Horizontal className='store-details-section-title tank cards section' span={24}>
        {cards.map((card) => (
          <Vertical key={card.title} className='spark-col' span={spanSize}>
            <ValueCard title={card.title} value={card.value} tankRundownData={tankRundownData} />
          </Vertical>
        ))}
      </Horizontal>
    )
  }

  function ValueCard({ title, value, tankRundownData }) {
    const isCurrentVolumeCard = title === 'Estimated Current Volume'
    const valueCardClassName = title === 'Estimated Current Volume' ? 'tank-info-card current-volume' : 'tank-info-card'
    return (
      <Card size='small' className={valueCardClassName} title={title} style={{ maxHeight: '87px' }}>
        <Row justify='space-between'>
          <Col>{value}</Col>
          {isCurrentVolumeCard && (
            <Popover
              content={<LastReadingPopover timezone={timezone} tankRundownData={tankRundownData} />}
              title={<Texto category='heading-small'>Last Reading</Texto>}
              trigger='hover'
            >
              <Col>
                <InfoCircleOutlined className='current-volume info-icon' />
              </Col>
            </Popover>
          )}
        </Row>
      </Card>
    )
  }

  return <HorizontalCardGroup title='Tank Information' cards={cards} tankRundownData={tankRundownData} />
}
